export default "__VITE_PUBLIC_ASSET__733c4a93__"